import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'three-thumbnail-section',
    templateUrl: './three-thumbnail-section.component.html',
    styleUrls: ['./three-thumbnail-section.component.scss'],
    standalone: false
})
export class ThreeThumbnailSectionComponent implements OnInit {
  @Input() giveSidePadding?: boolean;

  thumbnailData: any[] = [
    {
      image: './assets/images/eduhealthcare-our-company.jpg',
      title: 'Discover EDU Healthcare',
      text: 'Discover why everyone wants to work with EDU Healthcare! Click below to learn more about our pay and benefits!'
    },
    {
      image: './assets/images/top-school-jobs.jpg',
      title: 'Search Top School Jobs',
      text: 'Search school jobs now and kickstart your career with EDU Healthcare school jobs! Click below to search jobs!'
    },
    {
      image: './assets/images/refer-a-friend.jpg',
      title: 'Refer A Friend',
      text: 'Help your friends by referring them to EDU Healthcare!'
    }
  ];

  constructor() { }

  ngOnInit(): void {
    if (!this.giveSidePadding || this.giveSidePadding === undefined) this.giveSidePadding = false;
  }
}
